<template>
              
  <div class="d-flex align-items-center flex-wrap ">
    <slot :title="title">
      <a href="#dataEditorModal" data-bs-toggle="modal" class="btn btn-sm text-primary ms-0 ps-0">
        {{title}}
      </a>
    </slot>
    


    <div class="modal fade" id="dataEditorModal" tabindex="-1" aria-labelledby="dataEditorModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="dataEditorModalLabel"> {{title}} <div v-if="!isCustomDate" class="d-inline fs-sm fw-light">({{rangeSummary }})</div></h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
          </div>
          <div class="modal-body overflow-auto">
            <div class="row calendar-override">
              <div class="col-12 col-lg-4 row">
                <div class="col-12 col-lg-12">
                  <div class="fw-bold d-flex">
                    Custom Ranges
                    <a href="#" class="ms-1  ms-auto" data-bs-container="body"  data-bs-toggle="popover"  data-bs-trigger="hover focus" data-bs-placement="bottom"  title="Custom date or date ranges" data-bs-content="Custom date or date ranges">
                      <i class="bi bi-question-circle" ></i>
                    </a>
                  </div>

                  <ul class="list-group">
                    <li v-for="(u,i) in customPeriodTypes"  class="list-group-item d-flex align-items-center p-1"  :class="{'active':selectedPeriodType===u, 'disabled':isEditing && !u.edit}" >
                      <button class="btn btn-sm text-primary" :class="{'text-light':selectedPeriodType===u}" @click="setStartPeriodType (u)">
                      {{ getPeriodTypeLabel(u, true) }}
                      </button>
                      <button v-if="u.pattern && selectedPeriodType===u" class="btn btn-sm ms-auto" :class="{'text-light':selectedPeriodType===u}" @click="u.edit=!u.edit" :disabled="paramError"><i class="bi bi-pencil"></i></button>
                    </li>
                  </ul>
                </div>
                <div class="col-12 col-lg-12 mt-lg-3 ">
                  <div class="fw-bold d-flex">
                    Dynamic Dates
                    <a href="#" class="ms-1 ms-auto" data-bs-container="body"  data-bs-toggle="popover"  data-bs-trigger="hover focus" data-bs-placement="bottom"  title="Date or dange ranges that change relative to today" data-bs-content="Custom date or date ranges">
                      <i class="bi bi-question-circle" ></i>
                    </a>
                  </div>
                  <ul class="list-group overflow-auto">
                    <li v-for="(u,i) in dynamicPeriodTypes"  class="list-group-item d-flex align-items-center p-1  fs-sm"  :class="{'active':selectedPeriodType===u, 'disabled':isEditing && !u.edit}" >
                      <div v-if="u.edit" class="d-flex flex-column" >
                        <div class="d-flex align-items-center" >
                          <template v-for="(v,i) in u.pieces">
                            <div v-if="v==='static'">
                              {{ u.params[i] }}
                            </div>

                            <input v-if="v==='num'" type="number" class="form-control mx-2 px-1"  v-model.number="u.params[i]" @change="setStartPeriodType (u)" >

                            <input v-if="v==='str'" type="text" class="form-control mx-2"  v-model="u.params[i]"  @change="setStartPeriodType (u)">
                          
                          </template>
                        </div>
                        <div class="d-flex align-items-center fs-sm text-danger" >{{ paramError }}</div>

                      </div>
                      <button v-else class="btn btn-sm text-primary" :class="{'text-light':selectedPeriodType===u}" @click="setStartPeriodType (u)">
                      {{ getPeriodTypeLabel(u, true) }}
                      </button>
                      <button v-if="u.pattern && selectedPeriodType===u" class="btn btn-sm ms-auto" :class="{'text-light':selectedPeriodType===u}" @click="u.edit=!u.edit" :disabled="paramError"><i class="bi bi-pencil"></i></button>
                    </li>
                  </ul>
                </div>
              </div> 



              <!--
              <div v-if="hasEndDynamicPeriod" class="col-12 col-md-6">
                <ul class="list-group">
                  <li v-for="(u,i) in endPeriodTypes"  class="list-group-item  d-flex"  :class="{'active':selectedEndPeriodType===u, 'disabled':isEditing && !u.edit}" >
                    <div v-if="u.edit" class="d-flex flex-column" >
                      <div class="d-flex align-items-center" >
                        <template v-for="(v,i) in u.pieces">
                          <div v-if="v==='static'">
                            {{ u.params[i] }}
                          </div>

                          <input v-if="v==='num'" type="number" class="form-control mx-2"  v-model.number="u.params[i]" @change="setEndPeriodType(u)" >

                          <input v-if="v==='str'" type="text" class="form-control mx-2"  v-model="u.params[i]"  @change="setEndPeriodType(u)">
                        
                        </template>
                      </div>
                      <div class="d-flex align-items-center fs-sm text-danger" >{{ paramError }}</div>

                    </div>
                    <button v-else class="btn btn-sm text-primary" :class="{'text-light':selectedEndPeriodType===u}" @click="setEndPeriodType(u)">
                    {{ getPeriodTypeLabel(u) }}
                    </button>
                    <button v-if="u.pattern && selectedEndPeriodType===u" class="btn btn-sm ms-auto" :class="{'text-light':selectedEndPeriodType===u}" @click="u.edit=!u.edit" :disabled="paramError"><i class="bi bi-pencil"></i></button>
                  </li>
                </ul>
              </div>
             -->
             <div class="col-12 col-lg-8">
                <div class="row ">
                  <div class="col-12 col-md-6  d-flex justify-content-center align-items-center">
                  
                  
                    <DatePicker ref="calendarStart" class="inline-block h-full" v-model="resolvedStartDate" :disabledDates="disabledStartDates" >
                      <template #footer>
                        <div class="w-full">
                          <VcDatePicker  v-model="resolvedStartDate" :enabled="isCustomDate" :maxValue="resolvedEndDate"/>
                        </div>
                      </template>
                    </DatePicker>
                  </div>
                  <div class="col-12 col-md-6  d-flex justify-content-center align-items-center">
                    

                    <DatePicker v-if="isDateRange"  ref="calendarEnd" class="inline-block h-full" v-model="resolvedEndDate"  :disabledDates="disabledEndDates" >
                      <template #footer>
                        <div class="w-full">
                          <VcDatePicker  v-model="resolvedEndDate" :enabled="isCustomDate" :minValue="resolvedStartDate"/>
                          <!--
                          <button
                            class="btn btn-sm"
                            @click="moveToday">
                            Today
                          </button>-->
                        </div>
                      </template>
                    </DatePicker>

                

                  
                  </div>


                  <div v-if="hasEndDynamicPeriod"  class="col dropdown d-flex align-items-center">
                      <template v-if="selectedEndPeriodType" >
                        <div v-if="selectedEndPeriodType.edit" class="d-flex flex-column" >
                          <div class="d-flex align-items-center" >
                            <template v-for="(v,i) in selectedEndPeriodType.pieces">
                              <div v-if="v==='static'">
                                {{ selectedEndPeriodType.params[i] }}
                              </div>

                              <input v-if="v==='num'" type="number" class="form-control mx-2 px-1"  v-model.number="selectedEndPeriodType.params[i]" @change="setEndPeriodType (selectedEndPeriodType)" >

                              <input v-if="v==='str'" type="text" class="form-control mx-2"  v-model="selectedEndPeriodType.params[i]"  @change="setEndPeriodType (selectedEndPeriodType)">
                            
                            </template>
                          </div>
                          <div class="d-flex align-items-center fs-sm text-danger" >{{ paramError }}</div>

                        </div>

                        <button v-else class="btn btn-sm dropdown-toggle" data-bs-toggle="dropdown" >
                            {{ getPeriodTypeLabel(selectedEndPeriodType, true) }}
                        </button>
                        <button v-if="selectedEndPeriodType.pattern" class="btn btn-sm"  @click="selectedEndPeriodType.edit=!selectedEndPeriodType.edit" :disabled="paramError"><i class="bi bi-pencil"></i></button>
                        <a href="#" class="text-primary" @click="removeEndPeriodType()" title="Remove"><i class="bi bi-x-circle"></i></a>
                      </template>

                      
                      <ul class="dropdown-menu">
                        <li v-for="(u,i) in endPeriodTypes"  class="list-group-item d-flex align-items-center" >
                          <button class="btn btn-sm text-primary"  @click="setEndPeriodType (u)">
                          {{ getPeriodTypeLabel(u, true) }}
                          </button>
                          
                        </li>
                      </ul>
                    </div>
                    <div v-else-if="hasStartDynamicPeriod && !hasEndDynamicPeriod && hasEndPeriodTypes" class="col d-flex align-items-center">
                      <a href="#" class="text-primary" @click="setDefaultDynamicEndPeriodType()"><i class="bi bi-plus"></i>Add dynamic end</a>
                    </div>
                  </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div v-if="rangeError" class="d-flex align-items-center fs-sm text-danger" >{{ rangeError }}</div>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" :disabled="isInvalidOutput" @click="applyDateRange">Apply</button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="cancelChanges">Cancel</button>
          </div>
        </div>
      </div>
    </div>

  </div>


</template>

<script>
//import { ref } from 'vue';
import {VcDateUtils} from '/src/visualcrossing-core/vcdateutils';
import { DatePicker } from 'v-calendar';
import 'v-calendar/style.css';
import '/src/website-core/VcUtils';
import VcDatePicker from './VcDatePicker.vue'
export default {
  name: 'DateRangeChooser',
  props: {
    sessionId:String,
    sessionState:Object,
    queryDefinition:Object,
    queryData:Object,
  },
  emits: ['change:daterange'],
  data() {
    return {
      periodTypes:[
            {id:"singledate",label:"Single date", rangetype:"single"},
            {id:"daterange",label:"Date Range", rangetype:"range"},
            {id:"default",label:"15 day forecast", rangetype:"range", dynamic:true},
            {id:"today",label:"Today", rangetype:"single", dynamic:true},
            {id:"yesterday",label:"Yesterday", rangetype:"single", dynamic:true},
            {id:"tomorrow",label:"Tomorrow", rangetype:"single", dynamic:true},
            {id:"yeartodate",label:"Year to date", rangetype:"range", dynamic:true},
            {id:"monthtodate",label:"Month to date", rangetype:"range", dynamic:true},
            {id:"lastNdays",label:"Last ([0-9]+) days", rangetype:"range", pattern:"(last)([0-9]+)(days)", dynamic:true, params:["last",7,"days"], pieces:["static", "num","static"]},
            {id:"nextNdays",label:"Next ([0-9]+) days", rangetype:"range", pattern:"(next)([0-9]+)(days)", dynamic:true, params:["next",7,"days"], pieces:["static", "num","static"]},
            {id:"lastNhours",label:"Last ([0-9]+) hours", rangetype:"range", pattern:"(last)([0-9]+)(hours)", dynamic:true, params:["last",24,"hours"], pieces:["static", "num","static"]},
            {id:"nextNhours",label:"Next ([0-9]+) hours", rangetype:"range", pattern:"(next)([0-9]+)(hours)", dynamic:true, params:["next",24,"hours"], pieces:["static", "num","static"]},
      ],
     
      queryDefn:null, 
      startPeriod:null,
      endPeriod:null,
      selectedPeriodType:null,
      selectedEndPeriodType:null,
      //calendar:null,
      paramError:null,
    }
  },
  methods:{
    cancelChanges() {
      let me=this;
      me.setPeriodFromQueryDefn(me.queryDefinition && JSON.parse(JSON.stringify(me.queryDefinition)));
    },  
    applyDateRange() {
      let me=this;
      me.$emit("change:daterange", me.startPeriod, me.endPeriod);
    },
    getPeriodTypeLabel(type, preventResolution) {
      let me=this;
      if (!preventResolution && !type.dynamic) {
        return me.rangeSummary;
      }

      if (!type.pattern) return type.label;
      
      return type.params.join(" ");
    },
    findPeriodTypeById(id) {
      let me=this;
      if (!id) return null;
      return me.periodTypes.reduce((a,d)=> {
        if (a) return a;

        if (d.id===id) return d;

        if (d.pattern) { 
          let match=id.match(d.pattern);
          if (match && match.length) {
            match.forEach( (e,i)=> {
            if (i===0) return;
            d.params[i-1]=e;
          });
          return d;
        }
      }
        return null;
      }, null);

    },
    identifyPeriodType(startPeriod,endPeriod) {
      let me=this;
      if (!startPeriod && !endPeriod) {
        me.selectedPeriodType= me.findPeriodTypeById("default");
        return;
      }
      const fromIsDate=me.safeDateFromIso(startPeriod);
      const toIsDate=me.safeDateFromIso(endPeriod);
      if (fromIsDate && !toIsDate) {
        me.selectedPeriodType= me.findPeriodTypeById("singledate");
        return;
      }
      if (fromIsDate && toIsDate) {
        me.selectedPeriodType=me.findPeriodTypeById("daterange");
        return;
      }
      let fixedFromItem=me.findPeriodTypeById(startPeriod);
      if (fixedFromItem) {
        me.selectedPeriodType=fixedFromItem;
        let fixedEndItem=me.findPeriodTypeById(endPeriod);
        if (fixedEndItem) {
          me.selectedEndPeriodType=fixedEndItem;
        }
        return;
      }
      
      me.periodTypes[1];

    },

   
    

    setStartPeriodType(newType) {
      let me=this;
      me.paramError=null;
      if (newType.id==='default') {
        //15 day forecast
        me.startPeriod=null;
        me.endPeriod=null;
      } else if (newType.params) {
        let period=newType.params.join("");
        let periodMatch=period.match(newType.pattern);
        if (!periodMatch) {
          me.paramError="Invalid parameter";
          return;
        }
        me.startPeriod=period;
        me.endPeriod=null;
        me.selectedEndPeriodType=null;
      } else if (newType.dynamic) {
        me.startPeriod=newType.id;
        me.endPeriod=null;
        me.selectedEndPeriodType=null;
      } else if (!newType.dynamic) {
        //direct assignment causes the vaues to be recalculated
        let startPeriod=me.resolvedStartDate && VcDateUtils.formatDateIso(me.resolvedStartDate);
        let endPeriod=me.resolvedEndDate && VcDateUtils.formatDateIso(me.resolvedEndDate);
        me.startPeriod=startPeriod;
        me.endPeriod=newType.id==="daterange"?endPeriod:null;
        me.selectedEndPeriodType=null;
      }
      if ((newType.id==="singledate" || newType.id==="daterange")  && !me.startPeriod) {
        me.startPeriod=VcDateUtils.formatDateIso(new Date());
       
      }

      if (newType.id==="daterange" && !me.endPeriod) {
        me.endPeriod=me.startPeriod;
      }

      me.selectedPeriodType=newType;
    },
    setDefaultDynamicEndPeriodType() {
      let me=this;
      if (me.hasEndPeriodTypes) {
        let newType=me.endPeriodTypes[0];
        me.setEndPeriodType(newType);
      } 
    },
    setEndPeriodType(newType) {
      let me=this;

      

      if (!newType) return;
      if (!newType.dynamic) {
        me.paramError="End period must be dynamic";
        return;
      }
      if (newType.params) {
        let period=newType.params.join("");
        let periodMatch=period.match(newType.pattern);
        if (!periodMatch) {
          me.paramError="Invalid parameter";
          return;
        }
      
        me.endPeriod=period;
      } else if (newType.dynamic) {
        me.endPeriod=newType.id;
      }


      me.selectedEndPeriodType=newType;
      
    },
    removeEndPeriodType() {
      let me=this;
      me.selectedEndPeriodType=null;
      me.endPeriod=null;
    },
   
    setPeriodFromQueryDefn(queryDefn) {
      let me=this;
      if (!queryDefn) {
        me.startPeriod=null;
        me.endPeriod=null;
        return;
      }

      me.startPeriod=queryDefn.startdate;
      me.endPeriod=queryDefn.enddate;
      me.identifyPeriodType(me.startPeriod, me.endPeriod)
      //me.selectedPeriodType=me.periodTypes[1];
    },
    safeDateFromIso(value) {
      if (!value) return null;
      let date=VcDateUtils.dateFromIsoLocal(value);
      return date && VcUtils.isValidDate(date) && date;
    },

   
    
  },
  computed:{
    disabledStartDates() {
      let me=this;
      if (me.isSingleDate && !me.hasStartDynamicPeriod)  return null;
      if (!me.isCustomDate) {
        
        return [{
            start: me.resolvedStartDate && VcDateUtils.addDays(me.resolvedStartDate, 1),
          }, {
            end: me.resolvedStartDate && VcDateUtils.addDays(me.resolvedStartDate, -1),
          }
        ]
      }

      return  [{
        start: me.resolvedEndDate,

      }]
      //
    },
    disabledEndDates() {
      let me=this;
      if (me.isSingleDate && !me.hasStartDynamicPeriod) return null;
      if (!me.isCustomDate || !me.isCustomEndDate) {
        return  [{
            start: me.resolvedEndDate && VcDateUtils.addDays(me.resolvedEndDate, 1),
          }, {
            end: me.resolvedEndDate && VcDateUtils.addDays(me.resolvedEndDate, -1),
          }
        ]
      }
      return  [{
        end: me.resolvedStartDate,
        
      }];
    },
    isInvalidOutput() {
      let me=this;
      if (me.paramError) return true;
      let startDate=me.resolvedStartDate;
      let endDate=me.resolvedEndDate;

      if (!startDate || (startDate && endDate && endDate.getTime()<startDate.getTime()))  {
        //me.paramError="End date cannot be before the start date";
        return true;
      }
      return false;
    },
    rangeError() {
      let me=this;
      if (me.paramError) return "Parameter error";
      let startDate=me.resolvedStartDate;
      let endDate=me.resolvedEndDate;

      if (!startDate || (startDate && endDate && endDate.getTime()<startDate.getTime()))  {
        return "End date cannot be before the start date";
      }

      return null;
    },
    isEditing() {
      let me=this;
      return me.periodTypes.reduce((a,d)=>{
        return a || d.edit;
      },false)
    },
    hasStartDynamicPeriod() {
      let me=this;
      return me.selectedPeriodType && me.selectedPeriodType.dynamic;
    },
    hasEndDynamicPeriod() {
      let me=this;
      return me.selectedEndPeriodType && me.selectedEndPeriodType.dynamic;
    },
    hasEndPeriodTypes() {
      let me=this;
      return me.endPeriodTypes && me.endPeriodTypes.length;
    },
    customPeriodTypes() {
      let me=this;
      return me.periodTypes.filter(( d)=>{
        return !d.dynamic;
      });
    },
    dynamicPeriodTypes() {
      let me=this;
      return me.periodTypes.filter(( d)=>{
        return d.dynamic;
      });
    },
    endPeriodTypes() {
      let me=this;
      let endDate;
      if (me.isCustomDate) {
        return [];
        } else {
          const dynamicRange=VcDateUtils.resolveDynamicDate(me.startPeriod);
          endDate= dynamicRange && (dynamicRange[1] || dynamicRange[0]);
        }

      
      if (!endDate) return [];

      return me.periodTypes.reduce((a, d)=>{
        if (!d.dynamic) return a;
        let id=d.id;
        if (d.params) {
          id=d.params.join("");
        }
        const dynamicRange=VcDateUtils.resolveDynamicDate(id);
        const periodEndDate= dynamicRange && (dynamicRange[1] || dynamicRange[0]);

        if (periodEndDate && periodEndDate.getTime()>=endDate.getTime()) {
          a.push(JSON.parse(JSON.stringify(d)));
        }

        return a;

      }, []);

    },
    isSingleDate() {
      let me=this;
      return !me.selectedPeriodType || me.selectedPeriodType.rangetype==='single';
    },
    isDateRange() {
      let me=this;
      return me.selectedPeriodType && (me.selectedPeriodType.rangetype==='range' || me.selectedEndPeriodType);
    },
    title() {
     let me=this;

     if (me.selectedPeriodType && me.selectedEndPeriodType) {
      return `${me.getPeriodTypeLabel(me.selectedPeriodType)} - ${me.getPeriodTypeLabel(me.selectedEndPeriodType)}`;
     } else  if (me.selectedPeriodType) {
      return `${me.getPeriodTypeLabel(me.selectedPeriodType)}`;
     }

     if (!me.startPeriod) {
      return "15 day forecast";
     } else if (me.endPeriod) {
      return `${me.startPeriod} - ${me.endPeriod}`;
     } else {
      return me.startPeriod;
     }
    //return `${me.startPeriod} - ${me.endPeriod} (${resolvedStartText} - ${resolvedEndText})`;
    },
    rangeSummary() {
      let me=this;
      let resolvedStartText=me.resolvedStartDate && VcDateUtils.formatDateIso(me.resolvedStartDate);

      if (me.isSingleDate) {
         return `${resolvedStartText}`;
      }
      let resolvedEndText=me.resolvedEndDate && VcDateUtils.formatDateIso(me.resolvedEndDate);
      return `${resolvedStartText} - ${resolvedEndText}`;
    },
    isCustomDate() {
      let me=this;
      let fromIsDate=me.safeDateFromIso(me.startPeriod);
      let toIsDate=me.safeDateFromIso(me.endPeriod);
      //const toIsDate=VcUtils.isValidDate(startPeriod);
      return fromIsDate?true:false;
      //VcDateUtils.dateFromIsoLocal(me.startPeriod);
      //return me.selectedPeriodType && (me.selectedPeriodType.id==='singledate' || me.selectedPeriodType.id==='daterange');
    },
    isCustomEndDate() {
      let me=this;
     // let fromIsDate=me.safeDateFromIso(me.startPeriod);
      let toIsDate=me.safeDateFromIso(me.endPeriod);
      //const toIsDate=VcUtils.isValidDate(startPeriod);
      return toIsDate?true:false;
      //VcDateUtils.dateFromIsoLocal(me.startPeriod);
      //return me.selectedPeriodType && (me.selectedPeriodType.id==='singledate' || me.selectedPeriodType.id==='daterange');
    },
    resolvedDateRange: {
      get: function () {
        let me=this;
        return {
          start: me.resolvedStartDate,
          end: me.resolvedEndDate
        }
      },
      set: function (newValue) {
        var me=this;
        
        if (!me.isCustomDate) return;
       
        
        me.startPeriod=newValue.start && VcDateUtils.formatDateIso(newValue.start);
        me.endPeriod=newValue.end && VcDateUtils.formatDateIso(newValue.end);
        //me.$emit("change:daterange", me.queryDefn);
      }
    },
    resolvedStartDate: {
      get: function () {
        var me=this;

       // if (!me.queryDefinition) return null;

        if (me.isCustomDate && me.startPeriod) {
          return VcDateUtils.dateFromIsoLocal(me.startPeriod);
        } else {
          const dynamicRange=VcDateUtils.resolveDynamicDate(me.startPeriod);
          return dynamicRange && dynamicRange[0];
        }

       
      },
      set: function (newValue) {
        var me=this;
        if (!me.isCustomDate) return;
        //let currentStartDate=me.safeDateFromIso(me.startPeriod);
       // me.endPeriod=null;
        /*
        let currentEndDate=me.safeDateFromIso(me.endPeriod);

       
        if (currentEndDate && currentEndDate.getTime()<newValue.getTime()) {
          me.startPeriod=VcDateUtils.formatDateIso(newValue);
        }
          */
        me.startPeriod=VcDateUtils.formatDateIso(newValue);
        //me.$emit("change:daterange", me.queryDefn);
      }
    },
    resolvedEndDate: {
      get: function () {
        var me=this;
       // if (!me.queryDefinition) return null;
        
        if (me.isCustomDate) {
          return me.endPeriod && VcDateUtils.dateFromIsoLocal(me.endPeriod);
        } else {
          const dynamicRange=VcDateUtils.resolveDynamicDate(me.endPeriod || me.startPeriod);
          return dynamicRange && (dynamicRange[1] || dynamicRange[0]);
        }

      },
      set: function (newValue) {
        var me=this;
        if (!me.isCustomEndDate) return;
        let currentStartDate=me.safeDateFromIso(me.startPeriod);
        let currentEndDate=me.safeDateFromIso(me.endPeriod);

        if (currentStartDate && currentStartDate.getTime()>newValue.getTime()) {
          me.startPeriod=VcDateUtils.formatDateIso(newValue);
        }
        me.endPeriod=VcDateUtils.formatDateIso(newValue);
        //me.$emit("change:daterange", me.queryDefn);
      }
    },
     
    
  },
  watch:{
    resolvedStartDate:{
      handler:function(newValue,oldValue) {
        let me=this;
        if (newValue && me.$refs.calendarStart) me.$refs.calendarStart.move(newValue);
      },
    },
    resolvedEndDate:{
      handler:function(newValue,oldValue) {
        let me=this;
        if (newValue && me.$refs.calendarEnd) me.$refs.calendarEnd.move(newValue);
      },
    },
    queryDefinition:{
        handler:function(newValue,oldValue) {
          var me=this;
          me.setPeriodFromQueryDefn(newValue);
          //me.queryDefn=newValue && JSON.parse(JSON.stringify(newValue));
        },
        deep: true
    },
  },
  mounted() {
    var me=this;
    me.setPeriodFromQueryDefn(me.queryDefinition && JSON.parse(JSON.stringify(me.queryDefinition)));
    //me.queryDefn=me.queryDefinition && JSON.parse(JSON.stringify(me.queryDefinition));
  
     
  },
  updated() {
    var me=this;
  
  },
  components: {
    DatePicker,
    VcDatePicker
   // CommonModals
  }
}
</script>

<style scoped>
 .calendar-override :deep(.vc-highlight) {
  background-color: #00628b !important;
}
.calendar-override :deep(.vc-nav-item) {
  color: #000000 !important;
}
.calendar-override :deep(.vc-nav-item.is-active) {
  color: #ffffff !important;
}
</style>
